import qs from 'query-string';
import Cookies from 'js-cookie';

/**
 * Add UTM parameters to cookie with 15 minutes expire
 * @returns {void}
 */
export function setUtmCookies() {
  var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
  var params = qs.parse(window.location.search);
  var utmKeys = Object.keys(params).filter(function (value) {
    return value.startsWith('utm_');
  });
  utmKeys.forEach(function (key) {
    Cookies.set(key, params[key], {
      expires: inFifteenMinutes
    });
  });
}

/**
 * Get the cookies that start with utm_ from the document
 * @returns {Array} An array of utm cookies
 */
export function getUtmCookies() {
  return document.cookie.split(';').map(function (cookie) {
    return cookie.trim();
  }).filter(function (value) {
    return value.startsWith('utm_');
  });
}

/**
 * Add the cookies from the document a url
 * @param {string} href - The URL we would like to add utm cookies to
 * @returns {string | null} the mutated URL or nothing
 */
export function addUtmQueryString(href) {
  if (!href) {
    return null;
  }
  var utmQueryString = getUtmCookies().join('&');
  if (utmQueryString) {
    href += (href.split('?')[1] ? '&' : '?') + utmQueryString;
  }
  return href;
}